import { useMutation as e } from "@maat/store-hooks";
import { authApi as t } from "@maat/api-main";
//#region src/queries/otp/useResendOtpMutation.ts
var n = () => e({ mutationFn: t.resendOtp });
//#endregion
export { n as useResendOtpMutation };
